// extracted by mini-css-extract-plugin
module.exports = {"box":"MenuButton_box__icBmP","paper":"MenuButton_paper__EFfZJ","text":"MenuButton_text__2zdka","button":"MenuButton_button__20cGO"};